var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c("gg-modal", {
        attrs: {
          "is-active": _vm.showModal
        },
        on: {
          close: _vm.clickSkipForNow
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function fn() {
              return [
                _c(
                  "div",
                  {
                    staticClass: "text-right",
                    staticStyle: {
                      "margin-right": "-15px"
                    }
                  },
                  [
                    _c(
                      "gg-btn",
                      {
                        staticClass: "text-none",
                        attrs: {
                          icon: "",
                          text: ""
                        },
                        on: {
                          click: _vm.clickSkipForNow
                        }
                      },
                      [
                        _c(
                          "v-icon",
                          {
                            staticClass: "pa-2",
                            attrs: {
                              color: "green"
                            }
                          },
                          [_vm._v(" mdi-close ")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          cols: "12"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "text-center"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "background-color": "#DBFCE7",
                                  "border-radius": "36px",
                                  width: "fit-content",
                                  display: "block",
                                  margin: "auto"
                                }
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "pa-2",
                                    attrs: {
                                      size: "36px",
                                      color: "green"
                                    }
                                  },
                                  [_vm._v(" mdi-shield-outline ")]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ]
                    ),
                    _c(
                      "v-col",
                      {
                        staticClass: "text-center pb-1",
                        attrs: {
                          cols: "12"
                        }
                      },
                      [
                        _c(
                          "h3",
                          {
                            staticClass: "text-center text-black",
                            staticStyle: {
                              color: "black !important"
                            }
                          },
                          [_vm._v(" Secure Your Account with 2FA ")]
                        )
                      ]
                    ),
                    _c(
                      "v-col",
                      {
                        staticClass: "text-center pt-0",
                        attrs: {
                          cols: "12"
                        }
                      },
                      [
                        _vm._v(
                          " Two-factor authentication adds an extra layer of security to your GreenGeeks account, protecting your websites and domains "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          cols: "1"
                        }
                      },
                      [
                        _c(
                          "v-icon",
                          {
                            staticClass: "mb-1",
                            attrs: {
                              color: "green"
                            }
                          },
                          [_vm._v(" mdi-check ")]
                        )
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          cols: "11"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              color: "black !important"
                            }
                          },
                          [_vm._v("Enhanced Security")]
                        ),
                        _c("div", [
                          _vm._v(
                            "Protect your account from unauthorized access even if your password is compromised"
                          )
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          cols: "1"
                        }
                      },
                      [
                        _c(
                          "v-icon",
                          {
                            staticClass: "mb-1",
                            attrs: {
                              color: "green"
                            }
                          },
                          [_vm._v(" mdi-lock-outline ")]
                        )
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          cols: "11"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              color: "black !important"
                            }
                          },
                          [_vm._v("Easy Setup")]
                        ),
                        _c("div", [
                          _vm._v(
                            "Set up in minutes using your smartphone and an authenticator app"
                          )
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          cols: "1"
                        }
                      },
                      [
                        _c(
                          "v-icon",
                          {
                            staticClass: "mb-1",
                            attrs: {
                              color: "green"
                            }
                          },
                          [_vm._v(" mdi-shield-outline ")]
                        )
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          cols: "11"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              color: "black !important"
                            }
                          },
                          [_vm._v("Industry Standard")]
                        ),
                        _c("div", [
                          _vm._v(
                            "Join millions of users who trust 2FA to keep their accounts safe"
                          )
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          cols: "12"
                        }
                      },
                      [
                        _c(
                          "gg-btn",
                          {
                            staticStyle: {
                              width: "100%"
                            },
                            attrs: {
                              primary: ""
                            },
                            on: {
                              click: _vm.open2FAModal
                            }
                          },
                          [_vm._v(" Enable Two-Factor Authentication ")]
                        )
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          cols: "6"
                        }
                      },
                      [
                        _c(
                          "gg-btn",
                          {
                            staticStyle: {
                              width: "100%"
                            },
                            attrs: {
                              secondary: ""
                            },
                            on: {
                              click: _vm.clickRemindMeLater
                            }
                          },
                          [_vm._v("Remind Me in 10 Days")]
                        )
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          cols: "6"
                        }
                      },
                      [
                        _c(
                          "gg-btn",
                          {
                            staticStyle: {
                              width: "100%"
                            },
                            attrs: {
                              secondary: ""
                            },
                            on: {
                              click: _vm.clickSkipForNow
                            }
                          },
                          [_vm._v("Skip for Now")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("two-factor-auth-modal", {
        attrs: {
          show: _vm.modal2FA
        },
        on: {
          close: _vm.close2FAModal
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }